module.exports = __webpack_public_path__ + "img/cloudflare.e287a50b.png";